import type { BookingDetails } from 'app/typings/core/admin/bookings/booking';

import { Contact } from './Contact/Contact';
import { Guest } from './Guest/Guest';
import { User } from './User/User';

type Props = {
  bookingDetails: BookingDetails;
};

export const LeftPanel = ({ bookingDetails }: Props) => {
  return (
    <>
      <User bookingDetails={bookingDetails} />
      <Guest customer={bookingDetails.customerData} />
      <Contact customer={bookingDetails.customerData} />
    </>
  );
};
